//src/app/features/questionnaires/edit/TaxQuestionnaire/Income/reducer.ts
import { combineReducers } from 'redux';
import corporationTrustReducer from './CorporationTrust/reducer';
import homeSaleReducer from './HomeSale/slice';
import investmentsReducer from './Investments/slice';
import otherIncomeReducer from './OtherIncome/slice';
import passiveIncomeReducer from './PassiveIncome/reducer';
import selfEmploymentReducer from './SelfEmployment/slice';
import wagesReducer from './Wages/reducer';

export default combineReducers({
  corporationTrust: corporationTrustReducer,
  homeSale: homeSaleReducer,
  investments: investmentsReducer,
  otherIncome: otherIncomeReducer,
  passiveIncome: passiveIncomeReducer,
  selfEmployment: selfEmploymentReducer,
  wages: wagesReducer,
});
